import { createContext, useContext } from 'react';

export const DataExplorerContext = createContext(null);

export const useDataExplorerContext = () => {
  const context = useContext(DataExplorerContext);
  return context ?? {};
};
